import {
  Icon
} from "./chunk-RMZQSXO2.js";
import {
  renderTypography
} from "./chunk-EFEPUABF.js";

// src/components/CurrencyAmount.tsx
import styled from "@emotion/styled";
import {
  CurrencyUnit,
  formatCurrencyStr,
  isCurrencyMap,
  mapCurrencyAmount
} from "@lightsparkdev/core";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function CurrencyAmount({
  amount,
  displayUnit = CurrencyUnit.SATOSHI,
  shortNumber = false,
  showUnits = false,
  includeEstimatedIndicator = false,
  fullPrecision = false,
  id,
  ml = 0,
  typography,
  unitsPerBtc
}) {
  const unit = displayUnit;
  const amountMap = isCurrencyMap(amount) ? amount : mapCurrencyAmount(amount, unitsPerBtc);
  const value = amountMap[unit];
  const defaultFormattedNumber = amountMap.formatted[unit];
  let formattedNumber = defaultFormattedNumber;
  if (shortNumber) {
    formattedNumber = formatCurrencyStr(
      { value: Number(value), unit },
      { precision: 1, compact: true }
    );
  } else if (fullPrecision) {
    formattedNumber = formatCurrencyStr(
      { value: Number(value), unit },
      { precision: "full" }
    );
  }
  if (showUnits) {
    formattedNumber += ` ${shorttext(unit, value)}`;
  }
  let content = formattedNumber;
  if (typography && typography.type) {
    content = renderTypography(typography.type, {
      size: typography.size,
      color: typography.color,
      children: formattedNumber
    });
  }
  return /* @__PURE__ */ jsxs(StyledCurrencyAmount, { ml, id, children: [
    includeEstimatedIndicator && "Est. ",
    /* @__PURE__ */ jsx(CurrencyIcon, { unit }),
    content
  ] });
}
var CurrencyIcon = ({ unit }) => {
  switch (unit) {
    case CurrencyUnit.BITCOIN:
      return /* @__PURE__ */ jsx(Icon, { name: "BitcoinB", width: 8, verticalAlign: -2, mr: 2 });
    case CurrencyUnit.SATOSHI:
      return /* @__PURE__ */ jsx(Icon, { name: "Satoshi", width: 8, verticalAlign: -2, mr: 2 });
    default:
      return null;
  }
};
var shorttext = (unit, value) => {
  const pl = value !== 1;
  switch (unit) {
    case CurrencyUnit.BITCOIN:
      return "BTC";
    case CurrencyUnit.MILLIBITCOIN:
      return "mBTC";
    case CurrencyUnit.MICROBITCOIN:
      return "\u03BCBTC";
    case CurrencyUnit.SATOSHI:
      return `sat${pl ? "s" : ""}`;
    case CurrencyUnit.MILLISATOSHI:
      return `msat${pl ? "s" : ""}`;
    default:
      return unit;
  }
};
var StyledCurrencyAmount = styled.span`
  color: inherit !important;
  white-space: nowrap;
  font-feature-settings:
    "tnum" on,
    "lnum" on;
  margin-left: ${({ ml }) => ml}px;
`;

export {
  CurrencyAmount,
  CurrencyIcon
};
